import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { UiButton, UiGradiantOutlinedBtn } from "../common/UiButton";
import { UiHorizontalButtonGroup } from "../common/UiHorizontalButtonGroup";

export const ConfirmationPopupOnboard = (props) => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();

  const goLogin = () => {
    navigate("/");
  };

  return (
    <>
      <div
        className={
          props.className ? props.className : "df-confirmation-message-popup"
        }
      >
        {props.icon}
        <h3 className="df-confirmation-message-popup__message">
          {props.message}
        </h3>
        {props.children}
        <UiHorizontalButtonGroup>
          <UiGradiantOutlinedBtn
            onClick={props?.buttonOneClick}
            className="df-red-gradiant-outlined-btn"
            name={t("Not Now")}
          />
          <UiButton
            onClick={goLogin}
            className="df-ui-dark-bg-btn"
            name={t("Log In")}
          />
        </UiHorizontalButtonGroup>
      </div>
    </>
  );
};
